export default __webpack_public_path__ + "static/media/img_area_0.21738348.svg";